"use client";

import React from "react";
import { ComponentConfig } from "@puckeditor/core";
import { businessData } from "@/data/business";

export interface ProcessStep {
  step: number;
  title: string;
  body: string;
}

export interface ProcessTimelineProps {
  heading?: string;
  subheading?: string;
  steps?: ProcessStep[];
}

export const ProcessTimelineBlock: ComponentConfig<ProcessTimelineProps> = {
  label: "Process Timeline Section",
  fields: {
    heading: { type: "text", label: "Section Heading" },
    subheading: { type: "textarea", label: "Section Subheading" },
    steps: {
      type: "array",
      getItemSummary: (s: any) => `Step 0${s.step}: ${s.title}`,
      arrayFields: {
        step: { type: "number", label: "Step Number" },
        title: { type: "text", label: "Title" },
        body: { type: "textarea", label: "Description" },
      },
      defaultItemProps: {
        step: 1,
        title: "Project milestone",
        body: "Describe the decision, deliverable, owner, and expected timeline for this phase.",
      },
    },
  },
  defaultProps: {
    heading: "From Technical Brief to Retail-Ready Dispatch",
    subheading: "A transparent five-phase pathway with development, production, testing, packaging, and dispatch timelines confirmed against the approved scope.",
    steps: businessData.process,
  },
  render: ({ heading, subheading, steps }) => {
    const list = steps && steps.length > 0 ? steps : businessData.process;

    return (
      <section className="sec sec-alt" id="process">
        <div className="container">
          <div className="sec-head">
            <h2>{heading}</h2>
            <p className="sec-sub">{subheading}</p>
          </div>
          <div className="process-list">
            {list.map((st) => (
              <div className="process-row" data-animate key={st.step}>
                <div className="process-num">
                  {st.step < 10 ? `0${st.step}` : st.step}
                </div>
                <div>
                  <h3>{st.title}</h3>
                  <p>{st.body}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  },
};
